import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../index';

const selectTranslationsState = (state: RootState) => state.translations;

// Fetch selectors
export const selectTranslations = createSelector(
    [selectTranslationsState],
    (translationsState) => translationsState.translations
);

export const selectFetchLoading = createSelector(
    [selectTranslationsState],
    (translationsState) => translationsState.queries.loading
);

export const selectFetchError = createSelector(
    [selectTranslationsState],
    (translationsState) => translationsState.queries.error
);

// Query selectors
export const selectSearchQuery = createSelector(
    [selectTranslationsState],
    (translationsState) => translationsState.queries.searchQuery
);

export const selectStatusFilter = createSelector(
    [selectTranslationsState],
    (translationsState) => translationsState.queries.statusFilter
);

export const selectPagination = createSelector(
    [selectTranslationsState],
    (translationsState) => ({
        page: translationsState.queries.page,
        pageSize: translationsState.queries.pageSize,
        totalPages: translationsState.queries.totalPages,
        totalRows: translationsState.queries.totalRows,
        nextToken: translationsState.queries.nextToken,
    })
);

// Create translation selectors
export const selectCreateLoading = createSelector(
    [selectTranslationsState],
    (translationsState) => translationsState.createRecord.loading
);

export const selectCreateError = createSelector(
    [selectTranslationsState],
    (translationsState) => translationsState.createRecord.error
);

// Edit translation selectors
export const selectEditingTranslation = createSelector(
    [selectTranslationsState],
    (translationsState) => translationsState.edit.translation
);

export const selectIsEditDialogOpen = createSelector(
    [selectTranslationsState],
    (translationsState) => translationsState.edit.dialogOpen
);

export const selectEditingLoading = createSelector(
    [selectTranslationsState],
    (translationState) => translationState.edit.loading
);

export const selectEditingError = createSelector(
    [selectTranslationsState],
    (translationState) => translationState.edit.error
);

// Approval selectors
export const selectApprovalLoading = createSelector(
    [selectTranslationsState],
    (translationsState) => translationsState.approvalDecline.loading
);

export const selectApprovalError = createSelector(
    [selectTranslationsState],
    (translationsState) => translationsState.approvalDecline.error
);

// Deactivation selectors
export const selectDeactivationLoading = createSelector(
    [selectTranslationsState],
    (translationsState) => translationsState.deactivate.loading
);

export const selectDeactivationError = createSelector(
  [selectTranslationsState],
  (translationsState) => translationsState.deactivate.error
);

// Success message selectors
export const selectCreateSuccess = createSelector(
  [selectTranslationsState],
  (translationsState) => translationsState.createRecord.success
);

export const selectEditingSuccess = createSelector(
  [selectTranslationsState],
  (translationsState) => translationsState.edit.success
);

export const selectApprovalSuccess = createSelector(
  [selectTranslationsState],
  (translationsState) => translationsState.approvalDecline.success
);

export const selectDeactivationSuccess = createSelector(
  [selectTranslationsState],
  (translationsState) => translationsState.deactivate.success
);